export default __webpack_public_path__ + "static/media/24-7-helpline.9a970aa9.svg";